import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function DownloadIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 16.25C5.41421 16.25 5.75 16.5858 5.75 17V19C5.75 19.1381 5.86193 19.25 6 19.25H18C18.1381 19.25 18.25 19.1381 18.25 19V17C18.25 16.5858 18.5858 16.25 19 16.25C19.4142 16.25 19.75 16.5858 19.75 17V19C19.75 19.9665 18.9665 20.75 18 20.75H6C5.0335 20.75 4.25 19.9665 4.25 19V17C4.25 16.5858 4.58579 16.25 5 16.25Z"
                fill="currentColor"
            />
            <path
                d="M10.7379 3.75C10.2236 3.75 9.79447 4.14312 9.74955 4.65555C9.59591 6.40826 9.56881 8.16959 9.66838 9.92584C9.42139 9.93949 9.1745 9.95531 8.92773 9.9733L7.43822 10.0819C6.86392 10.1237 6.54288 10.7641 6.85293 11.2493C7.91497 12.9114 9.28343 14.3563 10.8854 15.5071L11.4821 15.9358C11.7916 16.1581 12.2085 16.1581 12.518 15.9358L13.1147 15.5071C14.7167 14.3563 16.0851 12.9114 17.1472 11.2493C17.4572 10.7641 17.1362 10.1237 16.5619 10.0819L15.0724 9.9733C14.8256 9.95531 14.5787 9.93949 14.3317 9.92584C14.4313 8.16959 14.4042 6.40826 14.2506 4.65554C14.2056 4.14312 13.7765 3.75 13.2622 3.75H10.7379Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
